import {jQuery as $} from 'mk/jQuery';

function check($content) {
    if ($content.height() > 300) {
        $content.closest('.truncated-message').removeClass('truncated-message-whole');
    }
}

export function exec(message) {
    let content = message.find('.truncated-message-content');

    message.find('a.truncated-message-show').on('click', function(e) {
        e.preventDefault();
        message.addClass('truncated-message-whole');
    });

    // Check immediately - most users
    check(content);
}

export function onLoad() {
    $('.truncated-message').each(function() {
        exec($(this));
    });
}
